import type { TaskItem, TaskStatus } from '../api/tasks.client.js';
import { getTaskStatusLabel } from './taskMeta.js';

export const TASK_KANBAN_STATUS_ORDER: readonly TaskStatus[] = [
  'todo',
  'in_progress',
  'blocked',
  'done',
  'cancelled',
];

export interface TaskKanbanCardModel {
  id: string;
  taskId: string;
  title: string;
  status: TaskStatus;
  priority: TaskItem['priority'];
  dueAt: string | null;
  assigneeName: string | null;
  dealTitle: string | null;
}

export interface TaskKanbanColumnModel {
  status: TaskStatus;
  title: string;
  count: number;
  cards: TaskKanbanCardModel[];
}

export function moveTaskStatus(
  tasks: readonly TaskItem[],
  taskId: string,
  toStatus: TaskStatus,
): TaskItem[] {
  return tasks.map((task) => (task.id === taskId ? { ...task, status: toStatus } : task));
}

function getAssigneeName(task: TaskItem): string | null {
  const assignee = task.assigneeMember?.user;
  if (!assignee) return null;

  const name = assignee.name.trim();
  return name.length > 0 ? name : assignee.email;
}

export function buildTaskKanbanColumns(tasks: readonly TaskItem[]): TaskKanbanColumnModel[] {
  return TASK_KANBAN_STATUS_ORDER.map((status) => {
    const statusTasks = tasks.filter((task) => task.status === status);

    return {
      status,
      title: getTaskStatusLabel(status),
      count: statusTasks.length,
      cards: statusTasks.map((task) => ({
        id: task.id,
        taskId: task.id,
        title: task.title,
        status: task.status,
        priority: task.priority,
        dueAt: task.dueAt ?? null,
        assigneeName: getAssigneeName(task),
        dealTitle: task.deal?.title ?? null,
      })),
    };
  });
}
